import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePopupStore, useViewSettingsStore } from "..";
import PopupType from "../interfaces/PopupType";

export default function useNavigateToDeal(): (id: number, forceDetails?: boolean) => void {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const popupStore = usePopupStore();
    const viewSettingsStore = useViewSettingsStore();

    return useCallback((id: number, forceDetails: boolean = false) => {
        const isPopupAlreadyOpen = popupStore.id === id && popupStore.type === PopupType.Deal;
        if (pathname !== `/deals/${id}` && (isPopupAlreadyOpen || forceDetails || viewSettingsStore.isMobile))
            navigate(`/deals/${id}`);
        else
            popupStore.openDealPopup(id);
    }, [popupStore.id, popupStore.type, pathname]);
}